import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'

interface BackUrgentOrderState extends ListState<any> {
    //orderInfo: createdata,
    //updateOrdeData: UpdateBackAbroadOrderStatu,
}

class BackUrgentOrderMutations extends ListMutations<any>{

}
class BackUrgentOrder extends ListModule<BackUrgentOrderState, any, any>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
        id: 0
    }
    actions = {
        async getAll(context: ActionContext<BackUrgentOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/BackUrgentOrder/GetUrgentDataList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async ProcessUrgentOrder(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackUrgentOrder/ProcessUrgentOrder', payload.data);
        },
    };
    mutations = {
        setCurrentPage(state: BackUrgentOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackUrgentOrderState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const backurgent = new BackUrgentOrder();
export default backurgent;